import {useTick} from "./useGame.js";

// The turn's countdown: thirty seconds to act, ten once nothing is playable. Its own
// component so the once-a-second re-render stays this small; the controller answers
// every number and word in it.
export function TurnClock({controller, compact = false}) {
  const clock = controller.turnClock();
  useTick(Boolean(clock));
  if (!clock) return null;
  return (
    <span className={`turn-clock${clock.urgent ? " urgent" : ""}${clock.stuck ? " stuck" : ""}`} role="timer">
      <span aria-hidden="true">⏱</span> {compact ? clock.short : clock.label}
    </span>
  );
}
